import React from 'react'
import { checkTextTranslation, checkTranslation, setObject, translate } from '../../utils/useful'
import Notebooksheet from '../../windows/Notebooksheet'
// import TextComponentFloatConfig from './TextComponentFloatConfig'
import { changeSelectedTextEffects } from '../../variables/notebook'
import { nanoid } from 'nanoid'
import TextComponentFloatConfig from './TextComponentFloatConfig'
import Modal from '../Modal'
import { stripHtml } from "string-strip-html";


class TextEditorInput extends React.Component {
    state = {
        editorId: nanoid()
    }


    changeValue = (value) => {

        // console.log("changeValue")
        // console.log(value)

        this.props.changeValue(this.props.header.key, value, this.props.extra)

    }

    componentDidMount() {
        // console.log('this.props.data', this.props?.data)
    }
    focus = () => {
        this.input.focus()
    }
    selectHandler = () => {
        // console.log('sssssssssssssssss');
    }

    // setElementSettings = (index, key, value) => {
    //     let elements = this.state.elements

    //     if (elements[index]) {
    //         setObject(elements[index], key, value)
    //     }
    //     this.setState({ elements })
    // }

    setData = (headerKey, key, value) => {
        let cardInfo = this.state.cardInfo
        cardInfo[headerKey] = cardInfo[headerKey] ?? {}
        cardInfo[headerKey][key] = value

        console.log(cardInfo)
        this.setState({ cardInfo })
    }


    updateTextEffectsStyleStatus = () => {

    }

    insertText = (text) => {
        // console.log("insertText")
        this.noteEditor.insertText(text)
    }


    render() {
        let header = this.props.header
        let fields = []

        // console.log(this.props.data)
        // if (this.props.data)
        //     console.log(stripHtml(this.props.data))

        return (
            <div className="w-100 h-100 postion-relative"  >
                {this.props.inplaceView ? (
                    <>
                        <div className='  w-100 h-100 cursor-pointer' onClick={() => this.modal.showModal()}>
                            <button className=' w-100 h-100 text-start'  >
                                {(this.props.data && String(stripHtml(this.props.data).result) != '') ? (
                                    <p className='w-100' style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{String(stripHtml(this.props.data).result)}</p>
                                ) : (
                                    <p className="placeholder w-100 h-100 text-start"> {this.props.information?.placeholder ?? translate('Text ...')}</p>
                                )}
                            </button>
                        </div>

                        <Modal ref={el => this.modal = el} maxWidth={600}>
                            <div className="flexcc flex-column p-3 bg-white br-15" >
                                <TextEditorInput header={this.props.header} data={this.props.data} changeValue={this.props.changeValue} extra={this.props.extra} variables={this.props.variables} params={this.props.params} />
                            </div>
                        </Modal>
                    </>
                ) : (
                    <>

                        {/* <input style={{ color: styleInfo?.textColor, fontWeight: styleInfo?.fontWeight, fontSize: styleInfo?.fontSize }} ref={el => this.input = el} autoFocus={this.props.header.information?.autoFocus} spellCheck={this.props.header.information?.spellCheck} value={this.props.data ? checkTranslation(this.props.data) : ''} onChange={(e) => this.changeInputValue(e.target)} onClick={() => this.selectHandler()} placeholder={checkTranslation(this.props.header.information?.placeholder)} disabled={this.props.header.information?.disabled} className="transpanet-input" /> */}
                        {header?.information?.showToolbar && (
                            <TextComponentFloatConfig
                                style={{ position: 'sticky', borderBottom: '1px solid #eeee', bottom: 'auto', top: 0, boxShadow: 'none' }} dontInvert={true}
                                changeSelectedTextEffects={(effectType, id) => changeSelectedTextEffects(effectType, id, this.updateTextEffectsStyleStatus)}
                                header={header} fields={fields} setData={this.setData} editorId={this.state.editorId} element={this.state.selectedElement} isToolbar={true} params={this.props.params} insertText={this.insertText}
                            />
                        )}

                        <Notebooksheet ref={el => this.noteEditor = el} header={this.props.header} data={this.props.data} id={this.props.editorId ?? this.state.editorId} changeValue={this.changeValue} updateTextEffectsStyleStatus={this.props.updateTextEffectsStyleStatus} hasPadding={header?.information?.showToolbar} />
                    </>
                )}





            </div>
        )
    }
}

export default TextEditorInput;